import { styled } from "@mui/material";

interface Props {
    isAuth?: boolean;
}

export const Styled = {
    Container: styled("div")<Props>`
        display: flex;
        align-items: center;
        justify-content: ${props => (props.isAuth ? "left" : "center")};
        padding: ${props => (props.isAuth ? "0px" : "10px")};
    `,
};
